import React from 'react';
import { formatCurrency } from '@/utils/formatters';

export default function ComparisonBanner({ currentTotal, prevTotal, currentMonthLabel, prevMonthLabel }) {
  if (!prevTotal) return null;

  const delta = currentTotal - prevTotal;
  const pct   = Math.abs(Math.round((delta / prevTotal) * 100));
  const lower = delta < 0;

  return (
    <div
      className={`mx-3 mb-2 rounded-card px-4 py-3 flex items-center gap-3
        border-l-4 ${lower ? 'bg-success-light border-success' : 'bg-red-50 border-danger'}`}
      role="status"
      aria-live="polite"
    >
      <span className="text-2xl" aria-hidden>{lower ? '📉' : '📈'}</span>
      <p className="text-xs font-medium text-gray-700">
        <span className="font-bold">{currentMonthLabel}: {formatCurrency(currentTotal)}</span>
        {' vs '}
        <span>{prevMonthLabel}: {formatCurrency(prevTotal)}</span>
        {' — '}
        <span className={`font-bold ${lower ? 'text-success' : 'text-danger'}`}>
          {formatCurrency(Math.abs(delta))} {lower ? 'lower' : 'higher'} {lower ? '▼' : '▲'} {pct}%
        </span>
      </p>
    </div>
  );
}
